import cn from "classnames"
import { DynamicHeadline } from "components/DynamicHeadline"
import parse from "html-react-parser"
import { stripHtmlSpaces } from "../../utils/strip-html-spaces"
import Section from "../Section"
import LinkButton from "../ui/LinkButton"
import styles from "./Wysiwyg.module.scss"

const Wysiwyg = ({ data, colors, content }) => {
  const {
    ankerslug,
    headline_teaser,
    wysiwyg,
    second_text,
    position,
    wysiwyg_2,
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
  } = data

  return (
    <Section
      id={ankerslug}
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      colors={colors}
    >
      {headline_teaser && (
        <p className={styles.headlineTeaser}>{headline_teaser}</p>
      )}
      <DynamicHeadline
        headlineType={headlineType?.value}
        headlineAppearance={headlineAppearance?.value}
      >
        {headline}
      </DynamicHeadline>
      <div
        className={cn(styles.wysiwyg_content, {
          [styles.secondText]: second_text,
          [styles.leftPosition]: position?.value === "left",
          [styles[`wysiwyg--${content.locale}`]]: content.locale,
        })}
      >
        <div className={styles.wysiwyg_wrapper}>
          <RenderBardWithComponents content={wysiwyg} prefix="wysiwyg_" />
        </div>
        {second_text && (
          <div className={styles.wysiwyg_wrapper}>
            <RenderBardWithComponents content={wysiwyg_2} prefix="wysiwyg_2_" />
          </div>
        )}
      </div>
    </Section>
  )
}

export const RenderBardWithComponents = ({ content, prefix, buttonClass }) => {
  if (typeof content === "string") {
    content = content.trim()
    if (!content.startsWith("<") || !content.endsWith(">")) {
      content = `<p>${content}</p>`
    }

    return <div>{parse(stripHtmlSpaces(content))}</div>
  }

  return (
    content &&
    content.length > 0 &&
    content.map((block, i) => {
      if (block.__typename === "BardText") {
        return (
          <div className={styles.textBlock} key={i}>
            {parse(stripHtmlSpaces(block.text))}
          </div>
        )
      }

      if (
        block.__typename.endsWith("_KontaktButton") ||
        block.__typename.endsWith("_LinkButton")
      ) {
        return (
          <LinkButton
            key={i}
            className={cn(styles.button, buttonClass)}
            data={{
              link_text: block[`${prefix}link_text`],
              link_blank: block[`${prefix}link_blank`],
              link_text: block[`${prefix}link_text`],
              link_url: block[`${prefix}link_url`],
            }}
          />
        )
      }

      if (block.__typename.endsWith("_Checklist")) {
        return (
          <div
            key={i}
            className={styles.checklist}
            dangerouslySetInnerHTML={{ __html: block.check_list }}
          />
        )
      }
    })
  )
}

export default Wysiwyg
